export const public_env = {
  base_folder: "/",
  id_school: "20328790"
};
